import React, { useEffect, useState } from 'react';
import { httpGetWaveForecastByStationId } from "../hooks/forecast/api";
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import ForecastChart from '../components/overview/ForecastChart';

const useStyles = makeStyles((theme) => ({
  root: {
      flexGrow: 1,
      marginTop: 0,
      padding: 15,
      backgroundColor: 'rgba(8,4,2,0.1)',
  
  },
  card: {
      padding: theme.spacing(2),
  },
  section: {
      height: "100%",
      paddingTop: 1,
      backgroundColor: 'rgba(5,4,2,0.1)',
  },
}));

export default function BuoysPage() {

  const classes = useStyles();   

  const [forecastTorreyPines, setForecastTorreyPines] = useState([]);
  const [forecastSanPedro, setForecastSanPedro] = useState([]);
  const [forecastOceanSide, setForecastOceanSide] = useState([]);

  // load waves FORECAST based on NOAA data (not real time)
  const loadData = () => {
    
    // torrey pines 
    let station_id = 46225
    httpGetWaveForecastByStationId(station_id).then( 
        (result) => { 
          setForecastTorreyPines(result);
    })

    // san pedro
    station_id = 46222
    httpGetWaveForecastByStationId(station_id).then( 
      (result) => { 
        setForecastSanPedro(result);
    })

    // ocean side
    station_id = 46224
    httpGetWaveForecastByStationId(station_id).then( 
      (result) => { 
        setForecastOceanSide(result);
    })
  }

  useEffect(() => {
      loadData();
  }, []);

  return (
    <div className={classes.root}>
        <Grid container spacing={1}>
            <Grid item xs={12}>
              <Card className={classes.section}>
                  <div>Forecast Wave Height (NOAA)</div>
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card className={classes.section}>
                  <ForecastChart forecast={forecastOceanSide} buoyName='Oceanside Offshore, Ca [46224]' />
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card className={classes.section}>
                  <ForecastChart forecast={forecastTorreyPines} buoyName='Torrey Pine [46225]' />
              </Card>
            </Grid>
            <Grid item xs={12}>
              <Card className={classes.section}>
                  <ForecastChart forecast={forecastSanPedro} buoyName='San Pedro, Ca [46222]' />
              </Card>
            </Grid>
           
        </Grid>
    </div>
  );
}
